import { http, tryHttp } from '@/axios/instance/http';

export const fetchFxRates = () => {
  return tryHttp(http.get<Record<string, number>>('/employeesv2/fx-rates'));
};
